import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getSentimentTypes } from '../helpers'
import * as Styles from './styles'

const SentimentLabel = ({ type, label }) => {
  const theme = useTheme()
  const sentiment = getSentimentTypes(theme)[type]

  const { Icon, iconColor } = sentiment

  if (!sentiment) return null

  return (
    <Styles.Container>
      <Icon size={20} weight="regular" color={iconColor} />
      <Text type="bodyMMedium">{label}</Text>
    </Styles.Container>
  )
}

export default SentimentLabel
